import { initializeApp } from 'firebase/app';
import { browserLocalPersistence, getAuth } from 'firebase/auth';
import { FIREBASE_APP_NAME, FIREBASE_CONFIG } from '../../constants/config';

const firebaseApp = initializeApp(FIREBASE_CONFIG, FIREBASE_APP_NAME);

export const firebaseAuth = getAuth(firebaseApp);

firebaseAuth.setPersistence(browserLocalPersistence);
